export default defineNuxtRouteMiddleware((to) => {
  if (checkRouteLocale('en', to.path) || checkRouteLocale('lt', to.path)) return
  const lang = useLocaleState().locale.value
  const { rewrite } = useI18nRouteRewrite()
  const next = lang ? rewrite(to, lang) : undefined
  if (next && next?.path !== to.path) return navigateTo(next, { redirectCode: 302 })
})
